import { Box, Flex, Heading, Text, Icon } from '@chakra-ui/react'
import { ElementType, ReactNode } from 'react'

interface SectionCardProps {
  title: string
  description: string
  icon: ElementType
  iconBgColor: string
  iconColor: string
  children: ReactNode
}

export const SectionCard = ({
  title,
  description,
  icon,
  iconBgColor,
  iconColor,
  children,
}: SectionCardProps) => {
  return (
    <Box
      bg="white"
      borderRadius="lg"
      p={6}
      w="100%"
      boxShadow="sm"
      border="1px"
      borderColor="gray.100"
    >
      <Flex alignItems="center" mb={6}>
        <Flex
          alignItems="center"
          justifyContent="center"
          bg={iconBgColor}
          color={iconColor}
          w={10}
          h={10}
          borderRadius="md"
          mr={4}
        >
          <Icon as={icon} boxSize={5} />
        </Flex>
        <Box>
          <Heading as="h3" size="sm" color="gray.800" fontWeight="bold">
            {title}
          </Heading>
          <Text fontSize="sm" color="gray.500">
            {description}
          </Text>
        </Box>
      </Flex>
      <Box>{children}</Box>
    </Box>
  )
}
